module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/206-rwanda-a27cc87baad4fc4ee3aae87c19ef1d90.svg";